module.exports = __webpack_public_path__ + "img/multiplier_5_en.0142cb21.png";